import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function ConfirmDialog({ open, onOpenChange, title, body, confirmLabel = "Delete", onConfirm, testId = "confirm-dialog" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-[#111D35] border-[#1F3358] text-white" data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl uppercase">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-300">{body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="btn btn-ghost" data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction className="btn bg-red-600 hover:bg-red-700 text-white" onClick={onConfirm} data-testid={`${testId}-confirm`}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
